import { atomWithReset } from "jotai/utils";

export const deleteProductPackageModalAtom = atomWithReset<{
  visible: boolean;
  data: {
    packageId: number;
    packageName: string;
  } | null;
}>({
  visible: false,
  data: null
});

export const deleteProductVariantModalAtom = atomWithReset<{
  visible: boolean;
  data: {
    variantId: number;
    packageIndex: number;
    variantIndex: number;
  } | null;
}>({
  visible: false,
  data: null
});
